module.exports = __webpack_public_path__ + "img/product1.93b76207.png";